/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateBadgeBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAllBadgesResponse } from '../models';
// @ts-ignore
import type { GetAllBadgesSub } from '../models';
// @ts-ignore
import type { GetBadgeTypeResponse } from '../models';
// @ts-ignore
import type { Message } from '../models';
// @ts-ignore
import type { UploadImageBadgeResponse } from '../models';
/**
 * BadgeApiApi - axios parameter creator
 */
export const BadgeApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateBadgeBody} createBadgeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeApiCreateNewBadge: async (createBadgeBody: CreateBadgeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBadgeBody' is not null or undefined
            assertParamExists('badgeApiCreateNewBadge', 'createBadgeBody', createBadgeBody)
            const localVarPath = `/badge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBadgeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [badgeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeApiDeleteBadge: async (badgeId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/badge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (badgeId !== undefined) {
                localVarQueryParameter['badge_id'] = badgeId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [milestoneNo] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {string} [segment] 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeApiGetBadge: async (milestoneNo?: number, page?: number, pageSize?: number, query?: string, segment?: string, type?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/badge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (milestoneNo !== undefined) {
                localVarQueryParameter['milestone_no'] = milestoneNo;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (segment !== undefined) {
                localVarQueryParameter['segment'] = segment;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeApiGetBadgeType: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/badge/type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetAllBadgesSub} getAllBadgesSub 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeApiUpdateBadge: async (getAllBadgesSub: GetAllBadgesSub, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAllBadgesSub' is not null or undefined
            assertParamExists('badgeApiUpdateBadge', 'getAllBadgesSub', getAllBadgesSub)
            const localVarPath = `/badge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAllBadgesSub, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeApiUploadBadgeImage: async (imageFile: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageFile' is not null or undefined
            assertParamExists('badgeApiUploadBadgeImage', 'imageFile', imageFile)
            const localVarPath = `/badge/upload-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (imageFile !== undefined) { 
                localVarFormParams.append('image_file', imageFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BadgeApiApi - functional programming interface
 */
export const BadgeApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BadgeApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateBadgeBody} createBadgeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async badgeApiCreateNewBadge(createBadgeBody: CreateBadgeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllBadgesSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.badgeApiCreateNewBadge(createBadgeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BadgeApiApi.badgeApiCreateNewBadge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [badgeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async badgeApiDeleteBadge(badgeId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.badgeApiDeleteBadge(badgeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BadgeApiApi.badgeApiDeleteBadge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [milestoneNo] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {string} [segment] 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async badgeApiGetBadge(milestoneNo?: number, page?: number, pageSize?: number, query?: string, segment?: string, type?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllBadgesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.badgeApiGetBadge(milestoneNo, page, pageSize, query, segment, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BadgeApiApi.badgeApiGetBadge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async badgeApiGetBadgeType(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBadgeTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.badgeApiGetBadgeType(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BadgeApiApi.badgeApiGetBadgeType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetAllBadgesSub} getAllBadgesSub 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async badgeApiUpdateBadge(getAllBadgesSub: GetAllBadgesSub, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllBadgesSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.badgeApiUpdateBadge(getAllBadgesSub, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BadgeApiApi.badgeApiUpdateBadge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async badgeApiUploadBadgeImage(imageFile: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadImageBadgeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.badgeApiUploadBadgeImage(imageFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BadgeApiApi.badgeApiUploadBadgeImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BadgeApiApi - factory interface
 */
export const BadgeApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BadgeApiApiFp(configuration)
    return {
        /**
         * 
         * @param {BadgeApiApiBadgeApiCreateNewBadgeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeApiCreateNewBadge(requestParameters: BadgeApiApiBadgeApiCreateNewBadgeRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAllBadgesSub> {
            return localVarFp.badgeApiCreateNewBadge(requestParameters.createBadgeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BadgeApiApiBadgeApiDeleteBadgeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeApiDeleteBadge(requestParameters: BadgeApiApiBadgeApiDeleteBadgeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Message> {
            return localVarFp.badgeApiDeleteBadge(requestParameters.badgeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BadgeApiApiBadgeApiGetBadgeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeApiGetBadge(requestParameters: BadgeApiApiBadgeApiGetBadgeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllBadgesResponse> {
            return localVarFp.badgeApiGetBadge(requestParameters.milestoneNo, requestParameters.page, requestParameters.pageSize, requestParameters.query, requestParameters.segment, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeApiGetBadgeType(options?: RawAxiosRequestConfig): AxiosPromise<GetBadgeTypeResponse> {
            return localVarFp.badgeApiGetBadgeType(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BadgeApiApiBadgeApiUpdateBadgeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeApiUpdateBadge(requestParameters: BadgeApiApiBadgeApiUpdateBadgeRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAllBadgesSub> {
            return localVarFp.badgeApiUpdateBadge(requestParameters.getAllBadgesSub, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BadgeApiApiBadgeApiUploadBadgeImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeApiUploadBadgeImage(requestParameters: BadgeApiApiBadgeApiUploadBadgeImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadImageBadgeResponse> {
            return localVarFp.badgeApiUploadBadgeImage(requestParameters.imageFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for badgeApiCreateNewBadge operation in BadgeApiApi.
 */
export interface BadgeApiApiBadgeApiCreateNewBadgeRequest {
    readonly createBadgeBody: CreateBadgeBody
}

/**
 * Request parameters for badgeApiDeleteBadge operation in BadgeApiApi.
 */
export interface BadgeApiApiBadgeApiDeleteBadgeRequest {
    readonly badgeId?: string
}

/**
 * Request parameters for badgeApiGetBadge operation in BadgeApiApi.
 */
export interface BadgeApiApiBadgeApiGetBadgeRequest {
    readonly milestoneNo?: number

    readonly page?: number

    readonly pageSize?: number

    readonly query?: string

    readonly segment?: string

    readonly type?: string
}

/**
 * Request parameters for badgeApiUpdateBadge operation in BadgeApiApi.
 */
export interface BadgeApiApiBadgeApiUpdateBadgeRequest {
    readonly getAllBadgesSub: GetAllBadgesSub
}

/**
 * Request parameters for badgeApiUploadBadgeImage operation in BadgeApiApi.
 */
export interface BadgeApiApiBadgeApiUploadBadgeImageRequest {
    readonly imageFile: File
}

/**
 * BadgeApiApi - object-oriented interface
 */
export class BadgeApiApi extends BaseAPI {
    /**
     * 
     * @param {BadgeApiApiBadgeApiCreateNewBadgeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public badgeApiCreateNewBadge(requestParameters: BadgeApiApiBadgeApiCreateNewBadgeRequest, options?: RawAxiosRequestConfig) {
        return BadgeApiApiFp(this.configuration).badgeApiCreateNewBadge(requestParameters.createBadgeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BadgeApiApiBadgeApiDeleteBadgeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public badgeApiDeleteBadge(requestParameters: BadgeApiApiBadgeApiDeleteBadgeRequest = {}, options?: RawAxiosRequestConfig) {
        return BadgeApiApiFp(this.configuration).badgeApiDeleteBadge(requestParameters.badgeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BadgeApiApiBadgeApiGetBadgeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public badgeApiGetBadge(requestParameters: BadgeApiApiBadgeApiGetBadgeRequest = {}, options?: RawAxiosRequestConfig) {
        return BadgeApiApiFp(this.configuration).badgeApiGetBadge(requestParameters.milestoneNo, requestParameters.page, requestParameters.pageSize, requestParameters.query, requestParameters.segment, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public badgeApiGetBadgeType(options?: RawAxiosRequestConfig) {
        return BadgeApiApiFp(this.configuration).badgeApiGetBadgeType(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BadgeApiApiBadgeApiUpdateBadgeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public badgeApiUpdateBadge(requestParameters: BadgeApiApiBadgeApiUpdateBadgeRequest, options?: RawAxiosRequestConfig) {
        return BadgeApiApiFp(this.configuration).badgeApiUpdateBadge(requestParameters.getAllBadgesSub, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BadgeApiApiBadgeApiUploadBadgeImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public badgeApiUploadBadgeImage(requestParameters: BadgeApiApiBadgeApiUploadBadgeImageRequest, options?: RawAxiosRequestConfig) {
        return BadgeApiApiFp(this.configuration).badgeApiUploadBadgeImage(requestParameters.imageFile, options).then((request) => request(this.axios, this.basePath));
    }
}

